// App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes,Navigate } from 'react-router-dom';
import Home from './pages/Home'
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Contact from './pages/Contact'
import Login from './pages/Login'
import Main from './pages/Main'
import { ADMIN_UID } from './config';
import AddStatDomaine from './pages/AddStatDomaine';
import ManageStatDom from './pages/ManageStatDom';
import  ViewStatDom from './pages/ViewStatDom';
import AddStatGenre from './pages/AddStatGenre';
import ManageStatGenre from './pages/ManageStatGenre';
import  ViewStatGenre from './pages/ViewStatGenre';
import FAQPage from './pages/FAQPage'
import AddJobConsultant from './pages/AddJobConsultant';
import AddJobStaff from './pages/AddJobStaff';
import ManageJobStaff from './pages/ManageJobStaff';
import ManageJobConsultant from './pages/ManageJobConsultant';
import RecrutementStaff from './pages/RecrutementStaff';
import RecrutementConsultant from './pages/RecrutementConsultant';
import ViewEtatFinan from './pages/ViewEtatFinan';
import AddEtatFinan from './pages/AddEtatFinan';
import AddActualite from './pages/AddActualite';
import ViewActualites from './pages/ViewActualites';
import ManageEtat from './pages/ManageEtat';
import AddProject from './pages/AddProject';
import CompletedProjectsPage from './pages/CompletedProjectsPage';
import OngoingProjectsPage from './pages/OngoingProjectsPage';
import ManageProjects from './pages/ManageProjects';
import ManageActs from './pages/ManageActs';
import Preloader from './components/Preloader';  // Import the Preloader component
import AddComite from './pages/AddComite';
import ManageComite from './pages/ManageComite';
import ViewComite from './pages/ViewComite';
import AddDocDown from './pages/AddDocDown';
import ManageDocDown from './pages/ManageDocDown';
import DocumentsPage from './pages/DocumentsPage';
import AddRefLegal from './pages/AddRefLegal';
import ManageRefLegal from './pages/ManageRefLegal';
import ViewRefLegal from './pages/ViewRefLegal';
const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <Preloader />;  // Show preloader while loading

  const ProtectedRoute = ({ element, ...rest }) => {
    return user ? (user.uid === ADMIN_UID ? element : <Navigate to="/" />) : <Navigate to="/la-connexion-de-ladmin-ong-el-wifak-bargou" />;
  };
  return (
    <Router>
        <div className="App">
           <Routes>
             <Route path='/' element={<Home/>}/>
             <Route path='/faq' element={<FAQPage/>}/>
             <Route path='/contact' element={<Contact/>}/>
             <Route path='/voirstatistiquesparsecteur' element={<ViewStatDom/>}/>
             <Route path='/voirstatistiquespargenre' element={<ViewStatGenre/>}/>
             <Route path='/recrutementStaff' element={<RecrutementStaff/>}/>
             <Route path='/recrutementConsultant' element={<RecrutementConsultant/>}/>
             <Route path='/lesetatsfinanciers' element={<ViewEtatFinan/>}/>
             <Route path='/lesActualites' element={<ViewActualites/>}/>
             <Route path='/projets-realises' element={<CompletedProjectsPage/>}/>
             <Route path='/projets-en-cours' element={<OngoingProjectsPage/>}/>
             <Route path='/Comite' element={<ViewComite/>}/>
             <Route path='/documents-a-telecharger' element={<DocumentsPage/>}/>
             <Route path='/references-juridiques' element={<ViewRefLegal/>}/>
             <Route path="/la-connexion-de-ladmin-ong-el-wifak-bargou"  element={<Login />} />

             <Route path="/la-connexion-de-ladmin-ong-el-wifak-bargou/main" element={<ProtectedRoute element={<Main />} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addStatDomaine' element={<ProtectedRoute element={<AddStatDomaine/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeStatDomaine' element={<ProtectedRoute element={<ManageStatDom/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addStatGenre' element={<ProtectedRoute element={<AddStatGenre/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeStatGenre' element={<ProtectedRoute element={<ManageStatGenre/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addJobConsultant' element={<ProtectedRoute element={<AddJobConsultant/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeJobConsultant' element={<ProtectedRoute element={<ManageJobConsultant/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addJobStaff' element={<ProtectedRoute element={<AddJobStaff/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeJobStaff' element={<ProtectedRoute element={<ManageJobStaff/>}/>} />
             <Route path="/la-connexion-de-ladmin-ong-el-wifak-bargou/addetatfinance" element={<ProtectedRoute element={<AddEtatFinan />} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addActualite' element={<ProtectedRoute element={<AddActualite/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addProject' element={<ProtectedRoute element={<AddProject/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeetats' element={<ProtectedRoute element={<ManageEtat/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeProjets' element={<ProtectedRoute element={<ManageProjects/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeActualites' element={<ProtectedRoute element={<ManageActs/>}/>} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addcomite' element={<ProtectedRoute element={<AddComite/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listecomite' element={<ProtectedRoute element={<ManageComite/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/adddoc' element={<ProtectedRoute element={<AddDocDown/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listedoc' element={<ProtectedRoute element={<ManageDocDown/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/addreflegal' element={<ProtectedRoute element={<AddRefLegal/>} />} />
             <Route path='/la-connexion-de-ladmin-ong-el-wifak-bargou/listereflegal' element={<ProtectedRoute element={<ManageRefLegal/>} />} />
           </Routes>
        </div>
    </Router>
  );
};

export default App;